import * as React from 'react'
import './App.css'
import {BrowserRouter, Routes, Route} from 'react-router-dom'
import Library from './pages/Library'
import Overview from './pages/Overview'
import Facilities from './pages/SubPages/Facilities'
import Rules from './pages/SubPages/Rules'
import DoNDont from './pages/SubPages/DoNDont'
import Timings from './pages/SubPages/Timings'
import Services from './pages/SubPages/Services'
import Staffs from './pages/SubPages/Staffs'
import EResources from './pages/SubPages/EResources'
import Collections from './pages/SubPages/Collections'
import OverviewCopy from './pages/Overview copy'
import { ParallaxProvider } from 'react-scroll-parallax';
function App() {

  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    // Simulate data fetching
    setTimeout(() => setIsLoading(false), 2000);
  }, []);

  

  return (
    <>
     <ParallaxProvider>
       <BrowserRouter>
        <Routes>
          <Route path='/' element={<Overview/>}  />
          <Route path='Library' element={<Library/>} />
          <Route path='Overview' element={<Overview/>} />
          <Route path='Facilities' element={<Facilities />}/>
          <Route path='Rules' element={<Rules/>} />
          <Route path='DoNDont' element={<DoNDont/>} />
          <Route path='Timings' element={<Timings/>} />
          <Route path='Services' element={<Services/>} />
          <Route path='Staffs' element={<Staffs/>} />
          <Route path='EResources' element={<EResources/>} />
          <Route path='Collections' element={<Collections/>}/>
          <Route path='test' element={<OverviewCopy/>}/>
        </Routes>
       </BrowserRouter>
     </ParallaxProvider>
    


    </>
  )
}

export default App
